export function autoLogout() {
  localStorage.removeItem("_user_session");
  localStorage.removeItem("_user_countdown");
  localStorage.removeItem("permissions");
  localStorage.removeItem("recoveryEmail");
  localStorage.removeItem("countdown");
  window.location.href = "/login";
}
